import { useEffect, useMemo, useState } from 'react';

import { PreviewList } from '@playbooks/molecules/lists';
import { SectionPanel, SectionPanelBody, SectionPanelFooter } from '@playbooks/molecules/panels/section-panel';
import { Button } from '@playbooks/ui/components/button';

import { SearchPreviewCard } from 'components/search/search-card';
import { useStorage } from 'contexts';
import { useQuery } from 'hooks';

const SearchResultsRecent = ({ api, tableName, tableNames, onClick, className = '' }) => {
	const [recent, setRecent] = useState([]);
	const [params, setParams] = useState<any>(api);
	const [meta, setMeta] = useState({ page: 0, pageSize: 0, totalRecords: 0 });
	const storage = useStorage();

	// Computed
	const computedHits = useMemo(() => {
		return recent.slice(api.page, api?.pageSize || 10).map(v => v.result);
	}, [JSON.stringify(recent)]);

	// Hooks
	useEffect(() => {
		fetchData();
	}, [tableName, storage.storage.search]);

	// Actions
	const [fetchData, loading] = useQuery(async () => {
		const queries = storage.storage.search || [];
		const formattedQueries = queries
			.filter(v => (tableName ? tableName === v.modelName : true))
			.filter(v => (tableNames.length > 0 ? tableNames.includes(v.modelName) : true))
			.sort((a, b) => (a.date < b.date ? 1 : -1));
		setRecent(formattedQueries);
		setMeta({ page: params.page, pageSize: params?.pageSize, totalRecords: formattedQueries.length });
	});
	const onClear = async () => {
		storage.storeValue('search', []);
		setRecent([]);
		setMeta({ page: 0, pageSize: 0, totalRecords: 0 });
	};

	// Render
	return (
		<SectionPanel>
			<SectionPanelBody className='py-3'>
				<PreviewList
					data={computedHits}
					loading={loading}
					icon='magnifying-glass'
					title='Search Results'
					className={className}>
					{computedHits.map((hit, index) => (
						<div key={index}>
							<SearchPreviewCard hit={hit} onClick={onClick} className='p-4' />
						</div>
					))}
				</PreviewList>
			</SectionPanelBody>
			<SectionPanelFooter>
				<Button variant='outline' size='sm' aria-label='clear' onClick={onClear} className='w-full'>
					Clear
				</Button>
			</SectionPanelFooter>
		</SectionPanel>
	);
};
export { SearchResultsRecent };
